import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  whseJob16IndexResetTimestamp: ['currentPage', 'sorts', 'filters', 'pageSize'],
  whseJob16IndexGoToWhseJobDocument: ['hdrId'],
  whseJob16IndexGoToAudit: ['hdrId'],
  whseJob16IndexFetchWhseJob16Index: ['currentPage', 'sorts', 'filters', 'pageSize'],
  whseJob16IndexFetchWhseJob16IndexLoading: ['boolean'],
  whseJob16IndexFetchWhseJob16IndexSuccess: [
    'documents',
    'currentPage',
    'lastPage',
    'total',
    'pageSize'
  ],
  whseJob16IndexAddSelectedDocuments: ['selectedDocuments'],
  whseJob16IndexRemoveSelectedDocuments: ['selectedDocuments'],
  whseJob16IndexSetWorkspaceVisible: ['boolean']
});

export const WhseJob16IndexTypes = Types;
export default Creators;
